import React from "react";
import { ISchool } from "src/services";
import Component from "../../../components/Component";
import Print, { IPrinter } from "../../../components/Print";
import withAppContext, {
  IAppContextProps,
} from "../../../components/withAppContext";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import l from "../../../l";

export type PrintEvaluationFunc = (
  school: ISchool,
  surveyId: number,
  coachId: number
) => Promise<void>;

interface IEvaluationPrinterProps {
  printEvaluationRef: (printEvaluation: PrintEvaluationFunc | null) => void;
}

interface IEvaluationPrinterState {}

type IProps = IEvaluationPrinterProps;

export default withAppContext(
  withAxios(
    class EvaluationPrinter extends Component<
      IProps & IAppContextProps & IAxiosProps,
      IEvaluationPrinterState
    > {
      public readonly state = this.buildState({});

      private printer?: IPrinter;

      public render() {
        return (
          <>
            <Print developerMode={false} printerRef={this.setPrinter} />
          </>
        );
      }

      public componentDidMount() {
        this.props.printEvaluationRef(this.getPrintEvaluationRef());
      }

      public componentDidUpdate(
        prevProps: IEvaluationPrinterProps,
        prevState: IEvaluationPrinterState
      ) {
        if (prevProps.printEvaluationRef !== this.props.printEvaluationRef) {
          prevProps.printEvaluationRef(null);
          this.props.printEvaluationRef(this.getPrintEvaluationRef());
        }
      }

      public componentWillUnmount() {
        this.props.printEvaluationRef(null);
      }

      private getPrintEvaluationRef() {
        return this.printer === undefined ? null : this.printEvaluation;
      }

      // private readonly printEvaluation = async (
      //   school: ISchool,
      //   surveyId: number,
      //   coachId: number
      // ) => {
      //   const {
      //     appContext: { baseUri },
      //   } = this.props;
      //   if (this.printer === undefined) {
      //     return;
      //   }
      //   // console.log("school.CoachReprot ", (school as any).CoachReprot);

      //   await this.printer.printUriAsync(
      //     baseUri +
      //       l`/__api/survey/${surveyId}/evaluation/${coachId}/print?schoolSlug=${school.slug}&isParentResponses=false&CoachReprot=${(school as any).CoachReprot}`
      //   );
        
      // };
      private readonly printEvaluation = async (
        school: ISchool,
        surveyId: number,
        coachId: number
      ) => {
        const {
          appContext: { baseUri },
        } = this.props;
      
        const url=baseUri +l`/__api/survey/${surveyId}/evaluation/${coachId}/print?schoolSlug=${school.slug}&isParentResponses=false&CoachReprot=${(school as any).CoachReprot}`

        const browserWindow: any = Function("return this")();
        const newTab = browserWindow.open(url, "_blank");
        if (newTab === null) {
          throw new Error("Could not open new tab for print.");
        }
      };
      
      private readonly setPrinter = (printer: IPrinter | null) => {
        this.printer = printer === null ? undefined : printer;
        this.props.printEvaluationRef(this.getPrintEvaluationRef());
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/evaluation/EvaluationPrinter.tsx